<template>
  <div id="prorrogacoesOuvidoria">
    <b-card header-tag="header" class="m-3" no-body>
      <b-overlay :show="loadingProrrogacoes">
        <b-card-body v-if="prorrogacoes && prorrogacoes.length > 0">
          <b-row
            class="text-left m-3"
            v-for="(prorrogacao, index) in prorrogacoes"
            :key="index"
          >
            <b-col cols="12" lg="6">
              <span>Data prorrogada: </span>
              <span>{{ formatData(prorrogacao.DataNova) }}</span>
            </b-col>
            <b-col cols="12" lg="6">
              <span>Última alteração: </span>
              <span
                >{{ formatData(prorrogacao.DataRegistro) }} por
                {{ formatarCPF(prorrogacao.IdUsuario) }}</span
              >
            </b-col>
            <b-col cols="12">
              <span>Justificativa: </span>
              <span v-html="prorrogacao.Justificativa" />
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-body v-else-if="!loadingProrrogacoes">
          Não houve prorrogação.</b-card-body
        >
      </b-overlay>
    </b-card>
  </div>
</template>

<script lang="ts">
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
import { ProrrogacaoOuvidoria } from "@/types/administracao/ouvidoria/prorrogacao-ouvidoria";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

const CompProps = Vue.extend({
  name: "ProrrogacoesOuvidoria",
  components: {},
  props: {
    idManifestacao: {
      type: Number,
      required: true,
    },
  },
});

@Component
export default class ProrrogacoesOuvidoria extends mixins(UtilsTS, CompProps) {
  prorrogacoes: ProrrogacaoOuvidoria[] = [];
  loadingProrrogacoes = true;

  async loadProrrogacoes(): Promise<void> {
    try {
      this.loadingProrrogacoes = true;
      this.prorrogacoes =
        await ouvidoriaService.getProrrogacoesByManifestacaoId(
          Number(this.idManifestacao)
        );
      this.prorrogacoes.reverse();
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingProrrogacoes = false;
    }
  }

  async mounted(): Promise<void> {
    await this.loadProrrogacoes();
  }
}
</script>

<style scoped>
div span:first-of-type {
  font-weight: bold;
}
</style>